import { pinyin, polyphonic } from '../../../node_modules/.pnpm/pinyin-pro@3.28.0/node_modules/pinyin-pro/dist/index.js';

const PinyinUtils = {
  /**
   * 判断拼音的音调是否是指定数字结尾
   * @param pinyin 带数字音调的拼音
   * @returns 是或否
   */
  toneIsEndsWith(pinyin2, end) {
    return pinyin2[pinyin2.length - 1] === end;
  },
  /**
   * 将数字音调0转为5
   * @param pinyin 带数字音调的拼音
   * @returns 转换后的拼音
   */
  convertTone0To5(pinyin2) {
    return this.toneIsEndsWith(pinyin2, "0") ? `${pinyin2.slice(0, pinyin2.length - 1)}5` : pinyin2;
  },
  /**
   * 通过文字获取多音字的拼音
   * @param text 中文文本
   * @returns 多音字的拼音数组
   */
  getPolyphone(text, toneType) {
    const pinyinList = polyphonic(text, {
      type: "array",
      toneType
    });
    if (toneType === "num") {
      return pinyinList.map((polyphoneList) => {
        return polyphoneList.map((pinyin2) => {
          return this.convertTone0To5(pinyin2);
        });
      });
    } else {
      return pinyinList;
    }
  },
  /**
   * 通过文字获取拼音
   * @param text 中文文本
   * @returns 拼音数组
   */
  getPinyin(text, toneType, multiple) {
    const pinyinList = pinyin(text, {
      type: "array",
      toneType,
      multiple
    });
    if (toneType === "num") {
      return pinyinList.map((pinyin2) => {
        return this.convertTone0To5(pinyin2);
      });
    } else {
      return pinyinList;
    }
  }
};

export { PinyinUtils };
//# sourceMappingURL=pinyin-utils.js.map
